// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4N3v_","question":"styles_question__3pBlt","inputVisibleButton":"styles_inputVisibleButton__3M3LJ","note":"styles_note__GeBs5"};